export default {
  term: '',
  courses: [],
  supervisors: [],
  filter: {
    area: '',
    course: [],
    supervisor: []
  }
}
